<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 网店展示
    </div>
    <div class="content-info">
      <h3 class="form-title flex-center">
        网店展示<span>（状态：<b v-if="state === 0">未提交</b>
        <b v-if="state === 1">已提交</b>
        <b v-if="state === 2">审核中 </b>
        <b v-if="state === 3">审核未通过</b>
        <b v-if="state === 4">审核中</b>
        <b v-if="state === 5">审核通过</b>
        <b v-if="state === 6">审核未通过</b>）</span>
      </h3>
      <div class="wd-box">
<!--        <div class="flex-start wd-style">-->
<!--          <span class="padding-xs">访问网址</span>-->
<!--          <div class="padding-xs wd-url">-->
<!--            http://www.gyh.wd.com/wd/178s-->
<!--          </div>-->
<!--        </div>-->
        <div class="flex-start wd-style">
          <span class="padding-xs">网店样式</span>
          <div class="wd-img">
            <img src="../../assets/img/1.jpg" alt="">
<!--            <router-link-->
<!--              to="/home/orgShop"-->
<!--              class="chiose-btn"-->
<!--            >-->
<!--              更换-->
<!--            </router-link>-->
          </div>
        </div>

      </div>
    </div>


  </div>
</template>
<script>
export default {
  name: "shop",
  data() {
    return {
      state:''
    }
  },
  created() {
    this.$emit('setIndex', 1)
    this.getOrgInfo()
  },
  methods:{
    /*
    *   获取机构基本信息
    * */
    getOrgInfo() {
      this.$api.apiContent.orgInfo({
        token: this.$store.state.user.token,
      }).then(res => {
        this.state = res.data.base_info.status
        this.wdId = res.data.base_info.shop_id
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.content-info {
  min-height: 950px;
  .form-title {
    height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }

    span {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #999999;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;

      b {
        color: #c70005;
      }
    }
  }
  .wd-box{
    width: 600px;
    padding: 30px 0;
    margin: 0 auto;
    .wd-style{
      margin-bottom: 30px;
      span{
        display: block;
        width: 120px;
        font-size: 16px;
      }
      .wd-url{
        flex: 1;
        border: 1px solid #eee;
      }
      .wd-img{
        flex: 1;
        img{
          display: block;
          width: 300px;
          margin: 0 auto;
        }
        .chiose-btn{
          display: block;
          width: 150px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border-radius: 20px;
          background-image: linear-gradient(90deg, #f9aa0d 0%, #e44730 100%), linear-gradient(#f9aa0d, #f9aa0d);
          color: #fff;
          font-size: 16px;
          margin: 30px auto;
        }
      }
    }
  }

}
</style>
